export default [
  {
    path: '/organization',
    name: 'organization',
    component: () => import('@/views/pages/partner/organization/List.vue'),
    meta: {
      name: 'organization',
      resource: 'Partner - Organisasi',
      action: 'manage',
    },
  },
  {
    path: '/organization/:id',
    name: 'organization-detail',
    component: () => import('@/views/pages/partner/organization/Detail.vue'),
    meta: {
      name: 'organization',
      resource: 'Partner - Organisasi',
      action: 'manage',
    },
  },
]
